import React from 'react';
import { PanelLeftIcon } from 'lucide-react';
interface FloatingButtonProps {
  onClick: () => void;
}
export const FloatingButton = ({
  onClick
}: FloatingButtonProps) => {
  return <button onClick={onClick} className="fixed top-6 left-6 p-2 bg-[#1a1a1a] hover:bg-[#2a2a2a] transition-colors rounded-lg border border-[#444444] z-50" data-id="element-121">
      <PanelLeftIcon size={20} className="text-[#4a90e2]" data-id="element-122" />
    </button>;
};